import { Tooltip } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { getCognitoUserData } from "../../../../features/auth/authSlice";
import { selectCompanies } from "../../../../features/company/companySlice";
import { Stats } from "../../../../features/reports/company/userStats";
import { UserRole } from "../../../../features/users/usersSlice";
import { CogIcon } from "../../../common/CogIcon";
import LoadingOverlay from "../../../common/LoadingOverlay";
import { BarChartSimple } from "../../common/BarChartSimple";
import { TopFiveAward } from "../../common/TopFiveAward";
import { fillWithEmptyDataIfNeeded } from "../../common/utils";
import styles from "./index.module.scss";
import { getTranslations } from "../../../../features/translations/translationsUtils";



interface Props {
  topFive: Stats[];
  isLoading: boolean;
}

export const CompanyTop5: React.FunctionComponent<Props> = ({
  topFive,
  isLoading,
}) => {
  const companyDict = useSelector(selectCompanies);
  const cognitoData = useSelector(getCognitoUserData);
  const role = cognitoData ? cognitoData["custom:role"] : undefined;
  const userCompanyId = cognitoData ? cognitoData["custom:company"] : undefined;
  const isInTop5 =
    companyDict &&
    topFive.find((item) => item.companyId === userCompanyId) !== undefined;

  const data = topFive.map((item) => ({
    key: item.companyId,
    label: companyDict[item.companyId]?.name ?? "",
    value: item.avgActiveUserPercentage.toFixed(2),
  }));

  const companyData = fillWithEmptyDataIfNeeded(data, 5);
  const TOOLTIP_TEXT = getTranslations('REPORT_TOP_5_ACTIVE_USERS_INFO');
  const TOOLTIP_TEXT2 = getTranslations('REPORT_TOP_10_ACTIVE_USERS_INFO');
  return (
    <>
      {role === UserRole.SuperAdmin && (
        <>
          <div className={styles.title}>
            {getTranslations('REPORT_TOP_5_ACTIVE_USERS')}
            <Tooltip
              placement="topLeft"
              title={TOOLTIP_TEXT}
              className={styles.tooltip}
            >
              <div>
                <CogIcon size="1.4em" color="#81858b" icon={"Attention"} />
              </div>
            </Tooltip>
          </div>
          {isLoading ? (
            <LoadingOverlay inline height={400} spinning />
          ) : (
            <div className={styles.chartContainer}>
              <BarChartSimple
                data={companyData}
                labelColumnTitle=" "
                fetching={isLoading}
                xMaxValue={100}
                xTickCallBack={(value: number) => (value + '%')}
                labelCallback={(tooltipItem: any, data: any) => {
                  const dataset = data.datasets[tooltipItem.datasetIndex];
                  return `${dataset.data[tooltipItem.index].x}%`;
                }}
              />
            </div>
          )}
        </>
      )}
      {role !== UserRole.SuperAdmin && (
        <>
          {isLoading ? (
            <LoadingOverlay inline height={400} spinning />
          ) : (
            <TopFiveAward
              isInTop5={isInTop5}
              tooltipText={TOOLTIP_TEXT2}
            />
          )}
        </>
      )}
    </>
  );
};
